<template>
  <base-submit-info-modal ref="rapidAccessTechnicalEvaluationModal"
                          :confirm-function="saveEvaluation"
                          confirm-button-title="Save evaluation"
                          modal-title="Rapid access technical evaluation"
                          size="full-response">
    <div class="row m-0 p-0">
      <div class="col-lg-6 ml-0 pl-0">
        <b-table :fields="proposalFields"
                 :items="[{...proposal, _showDetails: true}]"
                 class="table-responsive"
                 head-variant="light"
                 responsive
                 striped>
          <template v-slot:cell(actions)="row">
            <action-download-pdf :proposal="row.item"/>
          </template>
          <template v-slot:row-details>
            <b-table :fields="proposalDetailsFields"
                     :items="[proposal]"
                     bordered
                     class="table-responsive"
                     hover
                     responsive
                     small
                     stacked>
            </b-table>
          </template>
        </b-table>
      </div>
      <div class="col-lg-6 mr-0 pr-0">
        <evaluations-summary-table :is-rapid-access-technical-modal="true"
                                   :value="proposal"/>
      </div>
    </div>

    <div class="row m-0 p-0">
      <rapid-access-technical-evaluation-form v-model="evaluation"
                                              :is-editable="isProposalEditable"/>
    </div>
  </base-submit-info-modal>
</template>

<script>
  import BaseSubmitInfoModal from '@/components/base-components/base-modals/BaseSubmitInfoModal';
  import RapidAccessTechnicalEvaluationForm
    from '@/components/evaluation/rapid-access/technical/RapidAccessTechnicalEvaluationForm';
  import { infrastructureMixin } from '@/mixins/infrastructure';
  import { setExperimentColorAndCommentsInProposal } from '@/helpers/evaluation/rapid-access/rapidAccessTechnicalEvaluation';
  import EvaluationsSummaryTable from '@/components/evaluation/EvaluationsSummaryTable';
  import ActionDownloadPdf from '@/components/actions/ActionDownloadPdf';

  export default {
    name: 'RapidAccessTechnicalEvaluationModal',
    components: {
      ActionDownloadPdf,
      BaseSubmitInfoModal,
      EvaluationsSummaryTable,
      RapidAccessTechnicalEvaluationForm,
    },
    mixins: [infrastructureMixin],
    props: {
      isEvaluationEditable: {
        type: Boolean,
        required: true,
      },
      proposalFields: {
        type: Array,
        default: () => [],
      },
      proposalDetailsFields: {
        type: Array,
        default: () => [],
      },
      proposalToEdit: {
        type: Object,
        required: true,
      },
    },
    data() {
      return { evaluation: {} };
    },
    computed: {
      proposal() {
        return setExperimentColorAndCommentsInProposal(this.proposalToEdit);
      },
      isProposalEditable() {
        return this.isEvaluationEditable && this.proposal.management_evaluation?.states?.name !== 'submitted';
      },
    },
    watch: {
      proposal(newValue) {
        this.evaluation = newValue?.technical_evaluation || {};
      },
    },
    methods: {
      hide() {
        this.$refs.rapidAccessTechnicalEvaluationModal.hide();
      },
      isEvaluationSubmittable() {
        return !!this.evaluation
          && (this.evaluation.feasibility !== 'UNFEASIBLE'
            || (this.evaluation.comments && this.evaluation.comments_for_user));
      },
      async saveEvaluation() {
        if (this.isEvaluationEditable) {
          this.$emit('save-evaluation', this.evaluation);
          if (!this.isEvaluationSubmittable()) {
            this.$notify({
              type: 'warn',
              title: 'For \'unfeasible\' evaluation comment is obligatory',
            });
          }
          this.hide();
        } else {
          this.$notify({ type: 'error', title: 'Evaluation is not editable' });
        }
      },
      show() {
        this.$refs.rapidAccessTechnicalEvaluationModal.show();
      },
    },
  };
</script>

<style scoped>
  .table-responsive {
    margin-bottom: 0;
  }
</style>
